/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class ProducerProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the Producer by ID
	 * @param {String|Number} pProducerID - The Producer ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getProducerByID(pProducerID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pProducerID)
			{
				this.pict.log.error('No Producer ID provided.');
				return reject(new Error('No Producer ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`Organization/${pProducerID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Producer: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the Producers
	 * @return {Promise<Array<any>>}
	 * @async
	 * @example
	 */
	getProducers()
	{
		return new Promise((resolve, reject) =>
		{
			// NOTE: Producers are a subset of Organizations set by the Type field
			const tmpSearchQuery = {
				filters: [
					{
						field: 'Type',
						comparator: 'EQ',
						target: 'Producer',
					},
				],
				orderBy: 'Name',
				orderDirection: 'ASC',
			};

			// Filter by customer if IDCustomer is present
			if (this.pict.AppData?.DocumentData?.ReportData?.IDCustomer)
			{
				tmpSearchQuery.filters.push({
					field: 'IDCustomer',
					comparator: 'EQ',
					target: this.pict.AppData?.DocumentData?.ReportData?.IDCustomer || 0,
				});
			}

			const tmpURL = `Organizations/` + this.pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery);

			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error('Failed to get Producers list.', pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = ProducerProvider;
module.exports.default_configuration = {};
